export const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/cases", label: "Cases" },
  { to: "/contact", label: "Contact" },
];

export const pagesDropdown = [
  { to: "/career", label: "Career" },
  { to: "/cooperation", label: "Cooperation" },
  { to: "/pricing", label: "Pricing" },
  { to: "/terms-conditions", label: "Terms & Conditions" },
];

export const slides = [
  {
    image: "/images/home/banner_slider_01.png",
    h1: "Welcome to VEA Group",
    h2: "Your Trusted Business Partner",
    p: "VEA Group - Your growth partner across every stage and every sector.",
  },
  {
    image: "/images/home/banner_slider_02.jpg",
    h1: "Grow With Us",
    h2: "Expert Guidance & Support",
    p: "Join hands with VEA Group for a sustainable growth journey.",
  },
];

export const imagesSummaries = [
  "/images/home/gallery-img-1.png", // keyboard
  "/images/home/gallery-img-2.png", // people
];

// List of brand images (excluding banners and gallery images)
export const brandImagesWorking = [
  "/images/home/asus_logo.svg",
  "/images/home/siam_logo.svg",
  "/images/home/aeon_logo.svg",
  "/images/home/avolta_logo.svg",
  "/images/home/lanbena_logo.svg",
  "/images/home/lofvn_logo.svg",
];

export const brandImagesDevelop = [
  "/images/home/shopee_logo.svg",
  "/images/home/tiktokshop_logo.svg",
  "/images/home/crystalstar_logo.svg",
  "/images/home/era_logo.svg",
  "/images/home/foodmap_logo.svg",
  "/images/home/sentryx_logo.svg",
];

export const veagroupLogo = "logo.png";

export const subsidiaries = [
  {
    name: "VEA Retail",
    image: "/images/home/vearetail_logo.jpg",
    url: "https://vearetail.com",
    info: "Directly engages in multi-industry retail business and acts as a co-seller alongside multinational factories and production units.",
  },
  {
    name: "VEA Tech",
    image: "/images/home/veatech_logo.jpg",
    url: "https://vea-tech.net",
    info: "Owns multinational Influencer booking and management platforms, while offering AI automation solutions to support partners and the VEA Group internally.",
  },
  {
    name: "VEA Media",
    image: "/images/home/veamedia_logo.jpg",
    url: "https://veamedia.net",
    info: "TikTok’s official partner in Vietnam and the US, delivering and executing IMC campaigns, Influencer Marketing, and E-commerce solutions for partners.",
  },
  {
    name: "VEA Consulting",
    image: "/images/home/veaconsulting_logo.jpg",
    url: "https://vea-law.com",
    info: "Provides in-depth consulting and solutions for business operations, corporate governance, and compliance, empowering partners to build a solid foundation.",
  },
  {
    name: "VEA Growth Academy",
    image: "/images/home/veaacademy_logo.jpg",
    url: "https://veaacademy.com",
    info: "Offers training programs on soft skills and digital technologies such as AI, Livestreaming, and more for partners and VEA Group’s internal teams.",
  },
];

interface CountryData {
  id: string;
  imgX: number; // percentage from left (flag image)
  imgY: number; // percentage from top (flag image)
  flagImg: string;
  info: {
    title: string;
    description: string;
    stats?: string[];
  };
}

export const countries: CountryData[] = [
  {
    id: "vietnam",
    imgX: 68.2,
    imgY: 56,
    flagImg: "/images/home/vietnam.png",
    info: {
      title: "Vietnam Market",
      description:
        "Our regional headquarters and central business operator.",
      stats: [
        "50+ Employees",
        "400+ Client & Partner",
        "TikTok’s Partner and Shopee’s Partner",
      ],
    },
  },
  {
    id: "asean",
    imgX: 68,
    imgY: 63,
    flagImg: "/images/home/asean.png",
    info: {
      title: "ASEAN Hub",
      description:
        "Helping Vietnamese brands grow across Southeast Asia.",
      stats: [
        "200 influencers",
        "Regional Partnerships",
        "Cross-border Solutions (Warehouse, compliance,..)",
      ],
    },
  },
  {
    id: "us",
    imgX: 27,
    imgY: 43,
    flagImg: "/images/home/us.png",
    info: {
      title: "US Market",
      description:
        "Expanding presence in the world's largest consumer market.",
      stats: [
        "Cooperated with 30+ local United States clients",
        "An official TikTok Partner in the United States",
        "Trading 2 US-made products across the cosmetic and F&B fields",
      ],
    },
  },
  {
    id: "uae",
    imgX: 58.2,
    imgY: 50.8,
    flagImg: "/images/home/uae.png",
    info: {
      title: "UAE Market",
      description:
        "A strategic gateway to access the Halal market in the region.",
      stats: [
        "The office is located in a Free Zone",
        "Collaborating with 2 F&B partners serving the Muslim community",
      ],
    },
  },
  {
    id: "mexico",
    imgX: 27.7,
    imgY: 50,
    flagImg: "/images/home/mexico.png",
    info: {
      title: "Mexico Market",
      description:
        "Accessing an open and high-potential market in the field of e-commerce.",
      stats: [
        "Business support in Mexico: compliance & influencer marketing",
        "In the process of becoming an official TikTok Partner in Mexico",
      ],
    },
  },
];
